import { FC, useEffect } from 'react';
import { Button } from '@glomopay/shadcn/button';

import { analytics, AnalyticsEventName, type AppErrorCode } from '@/features/analytics/public';

interface TenantErrorScreenProps {
  errorCode: AppErrorCode.TENANT_UNAVAILABLE | AppErrorCode.TENANT_NOT_WHITELABEL;
  onRetry: () => void;
}

export const TenantErrorScreen: FC<TenantErrorScreenProps> = ({ errorCode, onRetry }) => {
  useEffect(() => {
    analytics.track(AnalyticsEventName.INVESTOR_APP_FAILED, { error_code: errorCode });
  }, [errorCode]);

  return (
    <main className='bg-bg-default flex min-h-dvh flex-col items-center justify-center gap-6 px-6 text-center'>
      <h1 className='text-text-primary text-2xl font-semibold' data-testid='tenant-error-heading'>
        Portal not available
      </h1>
      <p className='text-text-secondary'>We couldn&rsquo;t load this portal. Please try again.</p>
      <Button variant='brandFill' onClick={onRetry} data-testid='tenant-error-retry-button'>
        Try again
      </Button>
    </main>
  );
};
